<template>
  <t-dropdown trigger="click" class="pagination__options-size-changer show" @on-visible-change="$_onTDropDownVisibleChange">
    <t-button class="pagination__options-size-select">
      {{ current }}{{ itemPerPage }}
      <t-icon :type="iconType?'chevron-up':'chevron-down'"></t-icon>
    </t-button>
    <t-dropdown-menu slot="list" class="pagination__options-size-list">
      <t-dropdown-item v-for="i in range" :key="i" @on-click="$_onTDropDownClick(i)">{{ i }}</t-dropdown-item>
    </t-dropdown-menu>
  </t-dropdown>
</template>
<script>
import Locale from '../../mixins/locale'
import { isPInt } from '../../utils/assist'

export default {
  name: 'TPageSizer',
  mixins: [Locale],
  props: {
    range: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      validator: value => isPInt(value) && value > 0,
      default: 5
    }
  },
  data() {
    return {
      current: this.$_getCurrent(),
      iconType: false
    }
  },
  computed: {
    itemPerPage() {
      return this.t('t.page.page')
    }
  },
  watch: {
    range(val) {
      if (val && val[0]) {
        if (val[0] !== this.current) {
          this.$_onTDropDownClick(val[0])
        }
      }
    }
  },
  methods: {
    // 设置私有方法
    $_onTDropDownClick(val) {
      this.current = val
      this.$emit('on-change', val)
    },
    $_onTDropDownVisibleChange(visible) {
      this.iconType = visible
    },
    $_getCurrent() {
      if (this.range[0] !== this.pageSize) {
        if (this.range.includes(this.pageSize)) {
          return this.pageSize
        }
      } else {
        return this.range[0]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// sizer.vue?2cd6b392